export class RegistrationConstants{
  static REGISTRATION_PAGE_ONE=1;
  static REGISTRATION_PAGE_TWO=2;
  static REGISTRATION_PAGE_HELP=3;

}
